"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherApprvalUpdateType = exports.ApprovalStepsUsersSearchType = exports.AuditTrailAction = void 0;
var AuditTrailAction;
(function (AuditTrailAction) {
    AuditTrailAction["REQUEST"] = "request";
    AuditTrailAction["APPROVE"] = "approve";
    AuditTrailAction["FINAL_APPROVE"] = "final_approve";
    AuditTrailAction["REJECT"] = "reject";
    AuditTrailAction["RETRACT"] = "retract";
    AuditTrailAction["COMMENT"] = "comment";
})(AuditTrailAction = exports.AuditTrailAction || (exports.AuditTrailAction = {}));
var ApprovalStepsUsersSearchType;
(function (ApprovalStepsUsersSearchType) {
    ApprovalStepsUsersSearchType["APPROVAL"] = "approval";
    ApprovalStepsUsersSearchType["REJECTION"] = "rejection";
})(ApprovalStepsUsersSearchType = exports.ApprovalStepsUsersSearchType || (exports.ApprovalStepsUsersSearchType = {}));
var VoucherApprvalUpdateType;
(function (VoucherApprvalUpdateType) {
    VoucherApprvalUpdateType["REQUEST"] = "request";
    VoucherApprvalUpdateType["APPROVE"] = "approval";
    VoucherApprvalUpdateType["REJECT"] = "rejection";
    VoucherApprvalUpdateType["RETRACT"] = "retraction";
})(VoucherApprvalUpdateType = exports.VoucherApprvalUpdateType || (exports.VoucherApprvalUpdateType = {}));
